module.exports = __webpack_public_path__ + "media/images/emblems/Hermenches-18b519332072cee8f5c93f2a750ad5e7.png";